//type类型说明  1(普通输入框)，2(选择框)，3(时间选择)，4(时间范围选择)
export default {
    '基坑支护验收': [{
        title:'分包单位',
        type: 2,
        name: 'company',
        value: '',
    },{
        title:'验收时间',
        type: 3,
        name: 'date',
        dateselect: false,
        value: '',
    },{
        title:'验收部位',
        type: 1,
        name: 'position',
        value: '',
    }],
    '马道验收记录': [{
        title:'总承包单位',
        type: 2,
        name: 'company',
        dateselect: false
    },{
        title:'搭设（安装）单位',
        type: 2,
        name: 'date',
        dateselect: false,
        value: '',
    },{
        title:'马道类型',
        type: 1,
        name: 'position',
        value: '',
    },{
        title:'验收部位',
        type: 1,
        name: 'position',
        value: '',
    },{
        title:'验收日期',
        type: 3,
        name: 'date',
        value: '',
    }],
    '人工挖(扩)孔桩防护检查(验收)': [{
        title:'总承包单位',
        type: 2,
        name: 'company',
        dateselect: false,
        value: '',
    },{
        title:'分包单位',
        type: 2,
        name: 'company',
        dateselect: false,
        value: '',
    },{
        title:'分包负责人',
        type: 1,
        name: 'person',
        value: '',
    },{
        title:'验收部位',
        type: 1,
        name: 'position',
        value: '',
    },{
        title:'验收日期',
        type: 4,
        name: 'date',
        dateselect: false,
        value: '',
    }],
    '模板工程验收': [{
        title:'验收部位',
        type: 1,
        name: 'position',
        value: '',
    },{
        title:'验收日期',
        type: 3,
        name: 'date',
        dateselect: false,
        value: '',
    },{
        title:'搭设高度',
        type: 1,
        name: 'height',
        value: '',
    }],
    '扣件式钢管模板支撑体系验收': [{
        title:'总承包单位',
        type: 2,
        name: 'company',
        dateselect: false,
        value: '',
    },{
        title:'分包单位',
        type: 2,
        name: 'company',
        value: '',
    },{
        title:'验收部位',
        type: 1,
        name: 'position',
        value: '',
    },{
        title:'高度(m)',
        type: 3,
        name: 'height',
        value: '',
    },{
        title:'验收日期',
        type: 3,
        name: 'date',
        value: '',
    }],
}